import { selectPermission } from 'api/User/selectors'
import type { PERMISSIONS } from 'api/User/types'
import type { ReactNode } from 'react'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'

interface Props {
  children: ReactNode
  permission: PERMISSIONS
}

function RestrictedView({ permission, children }: Props) {
  const show = useSelector(selectPermission(permission))

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return show ? <>{children}</> : null
}

export default memo(RestrictedView)
